import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { CreditSummaryModel } from '../../cmg-1003/models/credit-summary.model';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): CreditSummaryModel {
  return <CreditSummaryModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-credit-summary-store' })
export class Cmg1003CreditSummaryStore extends Store<CreditSummaryModel> implements iStoreActions<CreditSummaryModel> {
  constructor() {
    super(createInitialState());
  }

  preInitialize(creditSummary: CreditSummaryModel): void {
    this.update(creditSummary);
  }
}
